import { createAction } from 'redux-act';
//////////////////////////////////////////////////

const setExpandedContainerError = createAction('setExpandedContainerError');
const setExpandedContainerOptions = createAction('setExpandedContainerOptions');
const setInitialExpandedContainer = createAction('setInitialExpandedContainer');

export {
  setExpandedContainerError,
  setExpandedContainerOptions,
  setInitialExpandedContainer,
};
